import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {ItemType} from '@emm/core/models/item-type.model';
import {standardRetry} from '@emm/core/util/rx.util';

@Injectable({
    providedIn: 'root',
})
export class ItemTypeService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}



    public getAllItemTypes(): Observable<ItemType[]> {
        return this.getItemTypes('/item-types');
    }



    public getAllItemTypesForItems(): Observable<ItemType[]> {
        return this.getItemTypes('/item-types/search/items');
    }



    public getAllItemTypesForItemGroups(): Observable<ItemType[]> {
        return this.getItemTypes('/item-types/search/groups');
    }



    private getItemTypes(path: string): Observable<ItemType[]> {
        return this.http.get<any>(this.apiUrl + path).pipe(
            map((response) => response),
            standardRetry()
        );
    }



    public getItemType(itemTypeTag: string): Observable<ItemType> {
        return this.http
            .get(this.apiUrl + '/item-types/' + itemTypeTag)
            .pipe(standardRetry());
    }



    public updateItemType(itemTypeTag: string, itemType: ItemType): Observable<ItemType> {
        return this.http
            .put(this.apiUrl + '/item-types/' + itemTypeTag, itemType)
            .pipe(standardRetry());
    }



    public createItemType(itemType: {
        classTag: string;
        description: string;
        name: string;
        tag: string;
    }): Observable<any> {
        return this.http
            .post(this.apiUrl + '/item-types', itemType, { responseType: 'text' })
            .pipe(standardRetry());
    }



    public deleteItemType(itemTypeTag: string): Observable<any> {
        return this.http.delete(this.apiUrl + '/item-types/' + itemTypeTag).pipe(standardRetry());
    }



}
